// src/Routes/router.jsx
import { createHashRouter, Navigate, RouterProvider } from "react-router-dom";
import MassCopy from "../Pages/ProjectManagement/ProjectTasks/MassCopy";
import ClientReports from "../Pages/ProjectManagement/Project/ClientReports";
import Clientredirect from "../Pages/ProjectManagement/Project/clientredirect";

import Login from "../Pages/AuthPages/Login/Login";
import PageNotFound from "../Exceptions/PageNotFound";
import RouteProtector from "./Layouts/IndexPageLayout";
import ForgotPassword from "../Pages/AuthPages/Forgot_Password/ForgotPassword";
import ResetPassword from "../Pages/AuthPages/Reset_Password/ResetPassword";
import Features from "../Components/Footer/Features";
import Pricing from "../Components/Footer/Pricing";
import Faq from "../Components/Footer/Faq";
import Terms from "../Components/Footer/Terms";
import Privacy from "../Components/Footer/Privacy";
import Cookies from "../Components/Footer/Cookies";
import Support from "../Components/Footer/Support";
import SystemStatus from "../Components/Footer/SystemStatus";
import CoverLayout from "../Pages/DataLayouts/CoverLayout";

import FreeTrialPage from "../Pages/AuthPages/FreeTrailPage/TrialPage";
import OtpVerify from "../Pages/AuthPages/OtpVerify/OtpVerify";
import useAuthStore from "../Zustand/Store/useAuthStore";
import PersonalizeDataGrid from "../Components/Table/PersonalizeDataGrid";
import { MAIN_URL } from "../Configurations/Urls";

import PMDashboard from "../Pages/ProjectManagement/Dashboard/PMDashboard";
import ClientContactList from "../Pages/ProjectManagement/ClientContact/ClientContactList";
import ClientContactForm from "../Pages/ProjectManagement/ClientContact/ClientContactForm";
import ClientList from "../Pages/ProjectManagement/Client/ClientList";
import ClientIndexRedirect from "../Pages/ProjectManagement/Client/ClientIndexRedirect";

import ClientForm from "../Pages/ProjectManagement/Client/ClientForm";
import ProjectList from "../Pages/ProjectManagement/Project/ProjectList";
import ProjectForm from "../Pages/ProjectManagement/Project/ProjectForm";
import ProjectTypeList from "../Pages/ProjectManagement/ProjectType/ProjectTypeList";
import ProjectTypeForm from "../Pages/ProjectManagement/ProjectType/ProjectTypeForm";
import ProjectCategoryList from "../Pages/ProjectManagement/ProjectCategory/ProjectCategoryList";
import ProjectCategoryForm from "../Pages/ProjectManagement/ProjectCategory/ProjectCategoryForm";
import ProjectTasksList from "../Pages/ProjectManagement/ProjectTasks/ProjectTasksList";
import ProjectTasksForm from "../Pages/ProjectManagement/ProjectTasks/ProjectTasksForm";
import ProjectTaskTemplateList from "../Pages/ProjectManagement/ProjectTaskTemplate/ProjectTaskTemplateList";
import ProjectTaskTemplateForm from "../Pages/ProjectManagement/ProjectTaskTemplate/ProjectTaskTemplateForm";

import TaskTimeLogList from "../Pages/ProjectManagement/TaskTimeLog/TaskTimeLogList";
import TaskTimeLogForm from "../Pages/ProjectManagement/TaskTimeLog/TaskTimeLogForm";
import MyProfilePage from "../Pages/MyProfile/MyProfilePage";
import ChangePassword from "../Pages/Settings/ChangePassword";
import UpdateCredentials from "../Pages/Settings/UpdateCredentials";
import OrganizationDetails from "../Pages/SignUpPages/OrganizationDetails";
import OrganizationAddInList from "../Pages/Orgnaization/Organisation/OrganizationAddInList";
import OrganizationProfile from "../Pages/Orgnaization/Profile/OrganizationProfile";
import ProjectTeamList from "../Pages/ProjectManagement/ProjectTeam/ProjectTeamList";
import ProjectTeamForm from "../Pages/ProjectManagement/ProjectTeam/ProjectTeamForm";
import ProjectTeamMemberList from "../Pages/ProjectManagement/ProjectTeamMember/ProjectTeamMemberList";
import ProjectTeamMemberForm from "../Pages/ProjectManagement/ProjectTeamMember/ProjectTeamMemberForm";
import ProjectMileStoneList from "../Pages/ProjectManagement/ProjectMileStone/ProjectMileStoneList";
import ProjectMileStoneForm from "../Pages/ProjectManagement/ProjectMileStone/ProjectMileStoneForm";
import ProjectTaskRecurrenceForm from "../Pages/ProjectManagement/ProjectTaskRecurrence/ProjectTaskRecurrenceForm";
import ProjectTaskRecurrenceList from "../Pages/ProjectManagement/ProjectTaskRecurrence/ProjectTaskRecurrenceList";
import ProjectTaskTypeList from "../Pages/ProjectManagement/ProjectTaskType/ProjectTaskTypeList";
import ProjectTaskTypeForm from "../Pages/ProjectManagement/ProjectTaskType/ProjectTaskTypeForm";
import ProjectDetail_v1 from "../Pages/ProjectManagement/Project/ProjectDetails_v1";
import ProjectSubCategoryList from "../Pages/ProjectManagement/ProjectSubCategory/ProjectSubCategoryList";
import ProjectSubCategoryForm from "../Pages/ProjectManagement/ProjectSubCategory/ProjectSubCategoryForm";
import ProjectTemplateList from "../Pages/ProjectManagement/ProjectTemplates/ProjectTemplateList";
import ProjectTemplateForm from "../Pages/ProjectManagement/ProjectTemplates/ProjectTemplateForm";
import ProjectTemplateMileStonesList from "../Pages/ProjectManagement/ProjectTemplateMileStones/ProjectTemplateMileStonesList";
import ProjectTemplateMileStonesForm from "../Pages/ProjectManagement/ProjectTemplateMileStones/ProjectTemplateMileStonesForm";
import ProjectTemplateTasksList from "../Pages/ProjectManagement/ProjectTemplateTasks/ProjectTemplateTasksList";
import ProjectTemplateTasksForm from "../Pages/ProjectManagement/ProjectTemplateTasks/ProjectTemplateTasksForm";
import ProjectTaskCategoryList from "../Pages/ProjectManagement/ProjectTaskCategory/ProjectTaskCategoryList";
import ProjectTaskCategoryForm from "../Pages/ProjectManagement/ProjectTaskCategory/ProjectTaskCategoryForm";
import ProjectTaskSubCategoryList from "../Pages/ProjectManagement/ProjectTaskSubCategory/ProjectTaskSubCategoryList";
import ProjectTaskSubCategoryForm from "../Pages/ProjectManagement/ProjectTaskSubCategory/ProjectTaskSubCategoryForm";
import MultiTableConfig from "../Pages/Orgnaization/DataGridSettings/MultiTableConfig";
import ClientDetail from "../Pages/ProjectManagement/Client/ClientDetail";
import ProjectTaskScheduleList from "../Pages/ProjectManagement/ProjectTaskSchedule/ProjectTaskScheduleList";
import ProjectTaskScheduleForm from "../Pages/ProjectManagement/ProjectTaskSchedule/ProjectTaskScheduleForm";
import InternProjectTasksForm from "../Pages/ProjectManagement/InternProjectTask/InternProjectTasksForm";
import InternProjectTasksList from "../Pages/ProjectManagement/InternProjectTask/InternProjectTasksList";
import InternTaskTimeLogList from "../Pages/ProjectManagement/InternTaskTimeLog/InternTaskTimeLogList";
import InternTaskTimeLogForm from "../Pages/ProjectManagement/InternTaskTimeLog/InternTaskTimeLogForm";
import InternProjectTaskScheduleForm from "../Pages/ProjectManagement/InternProjectTaskSchedule/InternProjectTaskScheduleForm";
import InternProjectTaskScheduleList from "../Pages/ProjectManagement/InternProjectTaskSchedule/InternProjectTaskScheduleList";
import OrganizationApplicationAccess from "../Pages/Orgnaization/Organisation/OrganizationApplicationAccess";
import OrganizationAddInForm from "../Pages/Orgnaization/Organisation/OrganizationAddInForm";
import OrganizationEntityList from "../Pages/Orgnaization/OrganizationEntity/OrganizationEntityList";
import OrganizationEntityForm from "../Pages/Orgnaization/OrganizationEntity/OrganizationEntityForm";
import OrganizationLocationList from "../Pages/Orgnaization/Location/OrganizationLocationList";
import OrganizationLocationForm from "../Pages/Orgnaization/Location/OrganizationLocationForm";
import OrganizationDepartmentsList from "../Pages/Orgnaization/Department/OrganizationDepartmentsList";
import OrganizationDepartmentForm from "../Pages/Orgnaization/Department/OrganizationDepartmentsForm";
import OrganizationDesignationsList from "../Pages/Orgnaization/Designations/OrganizationDesignationsList";
import OrganizationDesignationsForm from "../Pages/Orgnaization/Designations/OrganizationDesignationsForm";
import WorkShiftList from "../Pages/Time & Attendence/WorkShifts/WorkShiftList";
import WorkShiftForm from "../Pages/Time & Attendence/WorkShifts/WorkShiftForm";
import Users from "../Pages/Users/Users";
import UsersAdd from "../Pages/Users/UsersAdd";
import UsersEdit from "../Pages/Users/UserEdit";
import EmployeeList from "../Pages/EmployeeManagement/Employees/EmployeesList";
import EmployeeExitList from "../Pages/EmployeeManagement/EmployeeExits/EmployeeExitList";
import EmployeeExitForm from "../Pages/EmployeeManagement/EmployeeExits/EmployeeExitForm";
import DynamicFormPage from "../Pages/DataLayouts/DynamicFormPage";
import UserRoleList from "../Pages/User Management/UserRoles/UserRoleList";
import UserRoleForm from "../Pages/User Management/UserRoles/UserRoleForm";
import RolePermissionList from "../Pages/User Management/RolePermission/RolePermissionList";
import RolePermissionForm from "../Pages/User Management/RolePermission/RolePermissionForm";
import ViewRolePermissionForm from "../Pages/User Management/RolePermission/ViewRolePermissionForm";
import UserPermissionList from "../Pages/User Management/UserPermission/UserPermissionList";
import UserPermissionForm from "../Pages/User Management/UserPermission/UserPermissionForm";
import ViewUserPermissionForm from "../Pages/User Management/UserPermission/ViewUserPermissionForm";

// Routes
const router = (org) =>
  createHashRouter([
  {
    path: "/",
    element: (
      <RouteProtector>
        <PMDashboard />
      </RouteProtector>
    ),
  },
  {
    path: "/start-free-trial",
    element: <FreeTrialPage />,
  },
  {
    path: "/start-free-trial/verify-otp",
    element: <OtpVerify />,
  },
  {
    path: "/start-free-trial/org-details",
    element: <OrganizationDetails />,
  },

  {
    path: "/login",
    element: <Login title={"Login"} />,
  },
  {
    path: "/forgot-password",
    element: <ForgotPassword title={"Forgot Password"} />,
  },
  {
    path: "/reset-password",
    element: <ResetPassword title={"Reset Password"} />,
  },
  {
    path: "/my-profile",
    element: (
      <RouteProtector>
        <MyProfilePage />
      </RouteProtector>
    ),
  },
  {
    path: "/settings/change-password",
    element: (
      <RouteProtector>
        <ChangePassword />
      </RouteProtector>
    ),
  },
  {
    path: "/settings/update-credentials",
    element: (
      <RouteProtector>
        <UpdateCredentials />
      </RouteProtector>
    ),
  },

  {
    path: "/organization",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        path: "switcher",
        element: <OrganizationAddInList />,
      },
      {
        path: "data-grid-settings",
        element: <MultiTableConfig />,
      },
    ],
  },

  {
    path: "/organization/application-access",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [{ index: true, element: <OrganizationApplicationAccess /> }],
  },

  {
    path: "/organization/employee/employee-details",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <EmployeeList /> },
      { path: "add", element: <DynamicFormPage mode="add" /> },
      { path: "edit/:id", element: <DynamicFormPage mode="edit" /> },
      { path: "view/:id", element: <DynamicFormPage mode="view" /> },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="Employees"
            datagridKey="Employees_grid"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employee?mode=2`}
            contextId="employees"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization/employee/employee-exits",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <EmployeeExitList /> },
      { path: "add", element: <EmployeeExitForm mode="add" /> },
      { path: "edit/:id", element: <EmployeeExitForm mode="edit" /> },
      { path: "view/:id", element: <EmployeeExitForm mode="view" /> },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="employee_exits"
            datagridKey="employee_exits_grid"
            filterModule="employee_exit"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/employee-exit?mode=2`}
            contextId="employee-exits"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/organization/details",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <OrganizationAddInList /> },
      { path: "add", element: <OrganizationAddInForm mode="add" /> },
      { path: "edit/:id", element: <OrganizationAddInForm mode="edit" /> },
      { path: "view/:id", element: <OrganizationAddInForm mode="view" /> },
    ],
  },
  {
    path: "/organization/profile",
    element: (
      <RouteProtector>
        <OrganizationProfile />
      </RouteProtector>
    ),
  },
  {
    path: "/organization/entity",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <OrganizationEntityList /> },
      { path: "add", element: <OrganizationEntityForm mode="add" /> },
      { path: "edit/:id", element: <OrganizationEntityForm mode="edit" /> },
      { path: "view/:id", element: <OrganizationEntityForm mode="view" /> },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_entities"
            datagridKey="organization_entities_grid"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/entity?mode=2`}
            contextId="entities"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization/location",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <OrganizationLocationList /> },
      { path: "add", element: <OrganizationLocationForm mode="add" /> },
      { path: "edit/:id", element: <OrganizationLocationForm mode="edit" /> },
      { path: "view/:id", element: <OrganizationLocationForm mode="view" /> },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_locations"
            datagridKey="Locations_grid"
            filterModule="organization_locations"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/location?mode=2`}
            contextId="locations"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization/departments",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <OrganizationDepartmentsList /> },
      { path: "add", element: <OrganizationDepartmentForm mode="add" /> },
      { path: "edit/:id", element: <OrganizationDepartmentForm mode="edit" /> },
      { path: "view/:id", element: <OrganizationDepartmentForm mode="view" /> },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="departments"
            datagridKey="departments_grid"
            filterModule="departments"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/department?mode=2`}
            contextId="departments"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization/designation",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <OrganizationDesignationsList /> },
      { path: "add", element: <OrganizationDesignationsForm mode="add" /> },
      { path: "edit/:id", element: <OrganizationDesignationsForm mode="edit" /> },
      { path: "view/:id", element: <OrganizationDesignationsForm mode="view" /> },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_designations"
            datagridKey="Designations_grid"
            filterModule="organization_designations"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/designation?mode=1`}
            contextId="designations"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/organization/work-shift",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <WorkShiftList /> },
      { path: "add", element: <WorkShiftForm mode="add" /> },
      { path: "edit/:id", element: <WorkShiftForm mode="edit" /> },
      { path: "view/:id", element: <WorkShiftForm mode="view" /> },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_work_shifts"
            datagridKey="organization_work_shifts_grid"
            filterModule="organization_work_shifts"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/workshift?mode=1`}
            contextId="work-shifts"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },

  {
    path: "/users",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <Users /> },
      { path: "add", element: <UsersAdd /> },
      { path: "edit/:id", element: <UsersEdit mode="edit" /> },
      { path: "view/:id", element: <UsersEdit mode="view" /> },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="Users"
            datagridKey="organization_users_grid"
            filterModule="organization_users"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/user?mode=2`}
            contextId="organization-users"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/application/user-roles",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <UserRoleList /> },
      { path: "add", element: <UserRoleForm mode="add" /> },
      { path: "edit/:id", element: <UserRoleForm mode="edit" /> },
      { path: "view/:id", element: <UserRoleForm mode="view" /> },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_roles"
            datagridKey="User Roles_grid"
            filterModule="organization_roles"
            dataApi={`${MAIN_URL}/api/organizations/${org?.organization_id}/userrole?mode=2`}
            contextId="user-roles"
            orgId={org?.organization_id}
          />
        ),
      },
    ],
  },
  {
    path: "/application/user-role-permission",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <RolePermissionList /> },
      { path: "add", element: <RolePermissionForm mode="add" /> },
      { path: "view/:id", element: <ViewRolePermissionForm mode="edit" /> },
      { path: "edit/:id", element: <RolePermissionForm mode="edit" /> },
    ],
  },
  {
    path: "/application/user-permission",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      { index: true, element: <UserPermissionList /> },
      { path: "add", element: <UserPermissionForm mode="add" /> },
      { path: "view/:id", element: <ViewUserPermissionForm mode="edit" /> },
      { path: "edit/:id", element: <UserPermissionForm mode="edit" /> },
    ],
  },

  // project management routes

  {
    path: "/",
    element: (
      <RouteProtector>
        <PMDashboard />
      </RouteProtector>
    ),
  },

  {
    path: "/project-task/interns",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <InternProjectTasksList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_project_tasks"
            datagridKey="Intern_tasks_grid"
            filterModule="organization_project_tasks"
            dataApi={`${MAIN_URL}/api/project-management/project-tasks?mode=1&per_page=all&organization_id=${org?.organization_id}&person_type_id=2`}
            contextId="Intern_tasks_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <InternProjectTasksForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <InternProjectTasksForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <InternProjectTasksForm mode="view" />,
      },
    ],
  },

  {
    path: "/project-task-schedule-timelog/interns",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <InternTaskTimeLogList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_project_task_schedule_time_logs"
            datagridKey="Project_task_schedule_timelog_grid"
            filterModule="organization_project_task_schedule_time_logs"
            dataApi={`${MAIN_URL}/api/project-management/project-task-schedule-timelog?mode=3&per_page=all&organization_id=${org?.organization_id}&person_type_id=2`}
            contextId="Project_task_schedule_timelog_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <InternTaskTimeLogForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <InternTaskTimeLogForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <InternTaskTimeLogForm mode="view" />,
      },
    ],
  },



  {
    path: "/project-task-schedule/interns",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <InternProjectTaskScheduleList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_project_task_schedules"
            datagridKey="Project_task_schedule_grid"
            filterModule="organization_project_task_schedules"
            dataApi={`${MAIN_URL}/api/project-management/project-task-schedule?mode=3&per_page=all&organization_id=${org?.organization_id}&person_type_id=2`}
            contextId="Project_task_schedule_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <InternProjectTaskScheduleForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <InternProjectTaskScheduleForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <InternProjectTaskScheduleForm mode="view" />,
      },
    ],
  },



  {
    path: "/client",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ClientIndexRedirect />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_clients"
            datagridKey="Clients_grid"
            filterModule="organization_clients"
            dataApi={`${MAIN_URL}/api/project-management/clients?mode=3&per_page=all&organization_id=${org?.organization_id}`}
            contextId="Clients_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <ClientForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ClientForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <ClientForm mode="view" />,
      },
      {
        path: "info/:id",
        element: <ClientDetail mode="info" />,
      },
    ],
  },

  {
    path: "/client-contact",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ClientContactList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_client_contacts"
            datagridKey="Client-Contacts_grid"
            filterModule="organization_client_contacts"
            dataApi={`${MAIN_URL}/api/project-management/client-contacts?mode=3&per_page=all&organization_id=${org?.organization_id}`}
            contextId="Client-Contacts_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <ClientContactForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ClientContactForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <ClientContactForm mode="view" />,
      },
    ],
  },
  {
    path: "/project",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ProjectList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_project_projects"
            datagridKey="Projects_grid"
            filterModule="organization_project_projects"
            dataApi={`${MAIN_URL}/api/project-management/projects?mode=3&per_page=all&organization_id=${org?.organization_id}`}
            contextId="Projects_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <ProjectForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ProjectForm mode="edit" />,
      },
      // {
      //   path: "detail/:id",
      //   element: <ProjectDetail />,
      // },
      {
        path: "view/:id",
        element: <ProjectForm mode="view" />,
      },
      {
        path: "info/:id",
        element: <ProjectDetail_v1  />,
      },
    ],
  },
  {
    path: "/project-reports",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <Clientredirect/>,
      }
      
    ],
  },
  {
    path: "/project-type",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ProjectTypeList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_project_types"
            datagridKey="Project Types_grid"
            filterModule="organization_project_types"
            dataApi={`${MAIN_URL}/api/project-management/project-types?mode=3&per_page=all&organization_id=${org?.organization_id}`}
            contextId="Project Types_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <ProjectTypeForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ProjectTypeForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <ProjectTypeForm mode="view" />,
      },
    ],
  },
  {
    path: "/project-category",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ProjectCategoryList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_project_categories"
            datagridKey="Project Categories_grid"
            filterModule="organization_project_categories"
            dataApi={`${MAIN_URL}/api/project-management/project-categories?mode=3&per_page=all&organization_id=${org?.organization_id}`}
            contextId="Project Categories_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <ProjectCategoryForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ProjectCategoryForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <ProjectCategoryForm mode="view" />,
      },
    ],
  },
  {
    path: "/project-sub-category",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ProjectSubCategoryList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_project_subcategories"
            datagridKey="Project Sub Categories_grid"
            filterModule="organization_project_subcategories"
            dataApi={`${MAIN_URL}/api/project-management/project-sub-categories?mode=3&per_page=all&organization_id=${org?.organization_id}`}
            contextId="Project Sub Categories_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <ProjectSubCategoryForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ProjectSubCategoryForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <ProjectSubCategoryForm mode="view" />,
      },
    ],
  },
  {
    path: "/project-templates",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ProjectTemplateList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_project_templates"
            datagridKey="Project Templates_grid"
            filterModule="organization_project_templates"
            dataApi={`${MAIN_URL}/api/project-management/project-templates?mode=3&per_page=all&organization_id=${org?.organization_id}`}
            contextId="Project Templates_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <ProjectTemplateForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ProjectTemplateForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <ProjectTemplateForm mode="view" />,
      },
    ],
  },
  {
    path: "/project-templates-milestone",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ProjectTemplateMileStonesList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_project_template_milestones"
            datagridKey="Project Templates Milestone_grid"
            filterModule="organization_project_template_milestones"
            dataApi={`${MAIN_URL}/api/project-management/project-template-milestone?mode=3&per_page=all&organization_id=${org?.organization_id}`}
            contextId="Project Templates Milestone_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <ProjectTemplateMileStonesForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ProjectTemplateMileStonesForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <ProjectTemplateMileStonesForm mode="view" />,
      },
    ],
  },
  {
    path: "/project-template-tasks",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ProjectTemplateTasksList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_project_template_tasks"
            datagridKey="Project Templates Tasks_grid"
            filterModule="organization_project_template_tasks"
            dataApi={`${MAIN_URL}/api/project-management/project-template-tasks?mode=3&per_page=all&organization_id=${org?.organization_id}`}
            contextId="Project Templates Tasks_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <ProjectTemplateTasksForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ProjectTemplateTasksForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <ProjectTemplateTasksForm mode="view" />,
      },
    ],
  },
  {
    path: "/project-team",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ProjectTeamList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_project_teams"
            datagridKey="Project_teams_grid"
            filterModule="organization_project_teams"
            dataApi={`${MAIN_URL}/api/project-management/project-teams?mode=3&per_page=all&organization_id=${org?.organization_id}`}
            contextId="Project_teams_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <ProjectTeamForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ProjectTeamForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <ProjectTeamForm mode="view" />,
      },
    ],
  },
  {
    path: "/project-team-member",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ProjectTeamMemberList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_project_team_members"
            datagridKey="Project_team_members_grid"
            filterModule="organization_project_team_members"
            dataApi={`${MAIN_URL}/api/project-management/project-team-members?mode=3&per_page=all&organization_id=${org?.organization_id}`}
            contextId="Project_team_members_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <ProjectTeamMemberForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ProjectTeamMemberForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <ProjectTeamMemberForm mode="view" />,
      },
    ],
  },
  {
    path: "/project-milestone",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ProjectMileStoneList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_project_milestones"
            datagridKey="Project_milestone_grid"
            filterModule="organization_project_milestones"
            dataApi={`${MAIN_URL}/api/project-management/project-milestone?mode=3&per_page=all&organization_id=${org?.organization_id}`}
            contextId="Project_milestone_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <ProjectMileStoneForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ProjectMileStoneForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <ProjectMileStoneForm mode="view" />,
      },
    ],
  },

  {
    path: "/project-task",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ProjectTasksList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_project_tasks"
            datagridKey="Project_tasks_grid"
            filterModule="organization_project_tasks"
            dataApi={`${MAIN_URL}/api/project-management/project-tasks?mode=3&per_page=all&organization_id=${org?.organization_id}&person_type_id=1`}
            contextId="Project_tasks_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <ProjectTasksForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ProjectTasksForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <ProjectTasksForm mode="view" />,
      },
      {
        path: "edit-v2/:id",
        element: <ProjectTasksForm mode="edit-v2" />,
      },
      {
        path: "MassCopy",
        element: <MassCopy  />,
      },
    ],
  },

  {
    path: "/project-task-categories",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ProjectTaskCategoryList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_project_task_categories"
            datagridKey="Project_task_category_grid"
            filterModule="organization_project_task_categories"
            dataApi={`${MAIN_URL}/api/project-management/project-task-category?mode=3&per_page=all&organization_id=${org?.organization_id}`}
            contextId="Project_task_category_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <ProjectTaskCategoryForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ProjectTaskCategoryForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <ProjectTaskCategoryForm mode="view" />,
      },
    ],
  },
  {
    path: "/project-task-subcategories",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ProjectTaskSubCategoryList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_project_task_subcategories"
            datagridKey="Project_task_sub_category_grid"
            filterModule="organization_project_task_subcategories"
            dataApi={`${MAIN_URL}/api/project-management/project-task-sub-category?mode=3&per_page=all&organization_id=${org?.organization_id}`}
            contextId="Project_task_sub_category_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <ProjectTaskSubCategoryForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ProjectTaskSubCategoryForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <ProjectTaskSubCategoryForm mode="view" />,
      },
    ],
  },
  {
    path: "/project-task-schedule",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ProjectTaskScheduleList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_project_task_schedules"
            datagridKey="Project_task_schedule_grid"
            filterModule="organization_project_task_schedules"
            dataApi={`${MAIN_URL}/api/project-management/project-task-schedule?mode=3&per_page=all&organization_id=${org?.organization_id}&person_type_id=1`}
            contextId="Project_task_schedule_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <ProjectTaskScheduleForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ProjectTaskScheduleForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <ProjectTaskScheduleForm mode="view" />,
      },
    ],
  },
  {
    path: "/project-task-recurrence",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ProjectTaskRecurrenceList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_project_task_recurrences"
            datagridKey="Project_task_recurrence_grid"
            filterModule="organization_project_task_recurrences"
            dataApi={`${MAIN_URL}/api/project-management/project-task-recurrence?mode=3&per_page=all&organization_id=${org?.organization_id}`}
            contextId="Project_task_recurrence_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <ProjectTaskRecurrenceForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ProjectTaskRecurrenceForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <ProjectTaskRecurrenceForm mode="view" />,
      },
    ],
  },
  {
    path: "/project-task-template",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ProjectTaskTemplateList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_project_task_templates"
            datagridKey="Project_task_template_grid"
            filterModule="organization_project_task_templates"
            dataApi={`${MAIN_URL}/api/project-management/project-task-template?mode=3&per_page=all&organization_id=${org?.organization_id}`}
            contextId="Project_task_template_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <ProjectTaskTemplateForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ProjectTaskTemplateForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <ProjectTaskTemplateForm mode="view" />,
      },
    ],
  },
  {
    path: "/project-task-type",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <ProjectTaskTypeList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_project_task_types"
            datagridKey="Project_task_type_grid"
            filterModule="organization_project_task_types"
            dataApi={`${MAIN_URL}/api/project-management/project-task-type?mode=3&per_page=all&organization_id=${org?.organization_id}`}
            contextId="Project_task_type_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <ProjectTaskTypeForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <ProjectTaskTypeForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <ProjectTaskTypeForm mode="view" />,
      },
    ],
  },

  {
    path: "/project-task-schedule-timelog",
    element: (
      <RouteProtector>
        <CoverLayout />
      </RouteProtector>
    ),
    children: [
      {
        index: true,
        element: <TaskTimeLogList />,
      },
      {
        path: "personalize-view",
        element: (
          <PersonalizeDataGrid
            tableName="organization_project_task_schedule_time_logs"
            datagridKey="Project_task_schedule_timelog_grid"
            filterModule="organization_project_task_schedule_time_logs"
            dataApi={`${MAIN_URL}/api/project-management/project-task-schedule-timelog?mode=3&per_page=all&organization_id=${org?.organization_id}&person_type_id=1`}
            contextId="Project_task_schedule_timelog_grid"
            orgId={org?.organization_id}
          />
        ),
      },
      {
        path: "add",
        element: <TaskTimeLogForm mode="add" />,
      },
      {
        path: "edit/:id",
        element: <TaskTimeLogForm mode="edit" />,
      },
      {
        path: "view/:id",
        element: <TaskTimeLogForm mode="view" />,
      },
    ],
  },

  // footer
  {
    path: "/features",
    element: <Features />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "/terms",
    element: <Terms />,
  },
  {
    path: "/privacy",
    element: <Privacy />,
  },
  {
    path: "/cookies",
    element: <Cookies />,
  },
  {
    path: "/support",
    element: <Support />,
  },
  {
    path: "/system-status",
    element: <SystemStatus />,
  },
  {
    path: "*",
    element: <PageNotFound />,
  },
  ]);

export default function AppRouter() {
  const { userData } = useAuthStore();
  const org = userData?.organization;
  return <RouterProvider router={router(org)} />;
}
